import React, { useEffect, useState } from "react";
import "./campaign.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Loader } from "@progress/kendo-react-indicators";
import moment from "moment";
import EditIcon from "../../../assets/common/EditIcon.svg";
import FileIcon from "../../../assets/common/ic_file.svg";
import EyeIcon from "../../../assets/common/ic_eye.svg";
import DownloadIcon from "../../../assets/common/ic_download.svg";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { Dialog } from "@progress/kendo-react-dialogs";
import UnsortIcon from "../../../assets/rewards/unsorted.svg";
import { Confirmation } from "../../../components/dialog/confirmation";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import momentTZ from 'moment-timezone';
import { Icon } from "@progress/kendo-react-common";
import NoNominee from "../../../assets/rewards/no_nominee.svg";

import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import {
  statusConfig,
  statusConfigForApprove,
  statusConfigForSubmitted,
  statusConfigForCreated,
  statusConfigForPublishScheduled,
  statusConfigForCampaignApprover,
  statusConfigForPendingNomination
} from "./configData";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { approveNominees, fetchCampaignAudit, fetchCampaignDetail, fetchCampaignMatrixList, fetchNominees, generateReward, updateCampaignStatus } from "../../../store/campaign";
import { REWARDS_CAMPAIGNS_ADD, REWARDS_CAMPAIGNS_DETAIL, REWARDS_CAMPAIGNS_LIST } from "../../../routes";
import DetailNomineeSortableTable from "./tables/detail_nominee_sortable_table";
import { Button } from "@progress/kendo-react-buttons";
import PendingApprovalNomineeSortableTable from "./tables/pending_approval_nominee_sortable_table";
import { TextArea } from "@progress/kendo-react-inputs";

export const CampaignDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const [detailLoading, setDetailLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showPublishValidatoin, setShowPublishValidation] = useState(false);
  const [auditLoading, setAuditLoading] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [auditData, setAuditData] = useState([]);
  const [nomineeList, setNomineeList] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [selectedNominee, setSelectedNominee] = useState([]);

  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [tempOldStatus, setTempOldStatus] = useState("");
  const [tempStatusData, setTempStatusData] = useState([]);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const [tempDate, setTempDate] = useState("");
  const [timeChange, setTimeChange] = useState(false);
  const [showEndDateError, setShowEndDateError] = useState(false);
  const [showPublishDialog, setShowPublishDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");


  const [tempId, setTempId] = useState("");

  const [showApproveConfirmDialog, setShowApproveConfirmDialog] = useState(false);
  const [rewardConfigurationList, setRewardConfigurationList] = useState([]);


  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.update_campaign"
  );

  const EditPermssion = checkPermission(
    userPermissions,
    "gamifications.update_campaign"
  );

  const CampaignApproverPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_approver"
  );

  const ApproverPermssion = checkPermission(
    userPermissions,
    "gamifications.approve_nominees"
  );


  const ValidatorPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_validator"
  );


  const AdminPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_admin"
  );

  const reloadMatrixList = () => {
    setDetailLoading(true);
    dispatch(fetchCampaignMatrixList(id)).then((res) => {
      const matrixList = res?.payload.data ?? []; // ✅ fallback to empty array

      setRewardConfigurationList(matrixList);


      setDetailLoading(false);

    });
  }

  const getData = () => {
    setDetailLoading(true);
    setAuditLoading(true);
    dispatch(fetchCampaignAudit(id)).then((res) => {

      if (res.payload.status_code === 200) {
        setAuditData(res.payload.data);
        setAuditLoading(false);
      } else {
        setAuditLoading(false);
        // alert(res.payload.message);
      }
    });
    dispatch(fetchCampaignDetail(id)).then((detail) => {

      setDetailData(detail.payload);


      if (detail.payload.type == "Predefined Task Based") {
        reloadMatrixList();
      } else {
        dispatch(fetchNominees(id)).then((res) => {
          if (res.payload.status === "success") {
            setNomineeList(res.payload.data);
            setDetailLoading(false);
          } else {
            setDetailLoading(false);
            // alert('res.payload.message');
          }
        });
      }


    });


  };
  useEffect(() => {
    getData();
  }, [id]);

  const approveNomineeList = async () => {
    setLoading(true);
    let nomineeData = { approved_nominees: selectedNominee }

    dispatch(approveNominees({ data: nomineeData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        navigate(REWARDS_CAMPAIGNS_LIST);
      } else {
        alert(payload.Message);
        setLoading(false);
      }
    });

  }

  const isShowUpdateStatus = (item) => {

    let isShow = true;

    if (item.status === "Draft" || item.status === "Rejected" || item.status === "Closed") {
      isShow = false;
    }

    if (item.status === "Pending Approval") {
      if (ApproverPermssion) {
        isShow = true;
      } else {
        isShow = false;
      }
    }

    if (!AdminPermssion && ValidatorPermssion) {
      isShow = false;
    }


    return isShow;
  };

  const clickUpdateStatus = () => {
    setTempDate(moment());

    const currentIndex = statusConfig.findIndex(status => status.name === detailData.status);

    const nextStatuses = currentIndex !== -1 ? statusConfig.slice(currentIndex + 1) : [];

    setTempStatusData(nextStatuses);
    if (detailData.status == "Published" || detailData.status == "Scheduled") {
      setTempStatusData(statusConfigForPublishScheduled)
    }
    if (detailData.status == "Pending Approval" && CampaignApproverPermssion) {
      setTempStatusData(statusConfigForCampaignApprover);
    }
    else if ((detailData.status == "Approved" || detailData.status == "Rejected") && CampaignApproverPermssion) {

      const currentIndex = statusConfigForPendingNomination.findIndex(status => status.name === detailData.status);

      const nextStatuses = currentIndex !== -1 ? statusConfigForPendingNomination.slice(currentIndex + 1) : [];

      setTempStatusData(nextStatuses);
    } else {
      if (AdminPermssion) {
        setTempStatusData(statusConfigForPublishScheduled);
      } else if (CampaignApproverPermssion) {
        setTempStatusData(statusConfigForPublishScheduled);
      }
    }

    if (detailData.status == "Pending Nomination") {
      setTempStatusData(statusConfigForPendingNomination);
    }

    if (ApproverPermssion && !AdminPermssion) {
      if (detailData.status == "Pending Approval") {
        setTempStatusData(statusConfigForCampaignApprover);
      } else {
        setTempStatusData(statusConfigForPublishScheduled);
      }
    }
    setTempId(detailData.pk);
    setTempStatus(detailData.status);
    setTempOldStatus(detailData.status);
    setTempStartDate(detailData.publish_on);
    setTempEndDate(detailData.publish_end);

    setShowUpdateStatus(true);
  };


  function getCampaignLabel(categoryName) {
    switch (categoryName) {
      case "FMP":
        return "FMP Commendations";
      case "Cares":
        return "Cares";
      case "Event":
        return "Event";
      case "HIRS":
        return "HIRS";
      default:
        return categoryName;
    }
  }

  const clickUpdateStatusRejectOnly = () => {
    setTempDate(moment());
    setTempStatusData(statusConfigForCampaignApprover);

    setTempId(detailData.pk);
    setTempStatus(detailData.status);
    setTempOldStatus(detailData.status);
    setTempStartDate(detailData.publish_on);
    setTempEndDate(detailData.publish_end);

    setShowUpdateStatus(true);
  };


  const updateStatus = () => {
    setTimeChange(false);
    setTempStartDate("");
    setShowPublishDialog(false);
    setLoading(true);

    const getstatus = statusConfig.find(status => status.name === tempStatus);

    let params = { status: getstatus.id, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") };
    if (tempStatus == "Rejected") {
      params = { status: getstatus.id, reason: rejectReason, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") }
    }
    setTempId("");
    setTempStatus("");
    setShowUpdateStatus(false);


    if (getstatus.name == "Published" || getstatus.name == "Scheduled") {
      dispatch(generateReward({ data: params, id: tempId })).then((rewardRes) => {
        console.log(rewardRes);

        if (rewardRes.payload.status_code === 200) {
          getData();
          setLoading(false);
          setRejectReason("");
        } else {
          alert(rewardRes.payload.message);
          setLoading(false);

        }
      });
    } else {
      dispatch(updateCampaignStatus({ data: params, id: tempId })).then((res) => {
        console.log(res);

        if (res.payload.status_code === 200) {
          getData();
          setLoading(false);
          setRejectReason("");

        } else {
          alert(res.payload.message);
          setLoading(false);

        }
      });
    }
  };

  const checkTimeForPublish = () => {
    setTempDate(moment());

    if (tempStatus == "Published") {
      const isPassed = moment().isAfter(moment(tempStartDate));

      if (isPassed) {
        setTimeChange(true);

      } else {
        setShowPublishDialog(true);
      }

    } else {
      updateStatus();
    }
  }

  const checkEndDateForPublish = () => {
    const isPassed = moment().isAfter(moment(tempEndDate));

    if (isPassed) {
      setShowEndDateError(true);
    } else {
      updateStatus();
    }
  }


  const getTime = () => {
    return tempDate.format('DD-MMM-YYYY hh:mm A');
  }



  const editRedirect = () => {
    navigate(`${REWARDS_CAMPAIGNS_ADD}?id=${id}`);
  };

  const getSortIcon = () => {
    return <Icon>
      <img alt="" src={UnsortIcon} />
    </Icon>;
  };


  const RenderRow = ({ title, value, isImage }) => {
    return (
      <>
        {value ? (
          <>
            <div className="campaigns_detail_child_box_main_detail_items">
              <div className="campaigns_detail_child_box_main_detail_items_title campaigns_detail_center_item detail_padding_bottom">
                {title}
              </div>
              <div className="campaigns_detail_child_box_main_detail_items_splitter" />
              <div className="campaigns_detail_center_item campaigns_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                {isImage ? (
                  <>
                    <img
                      style={{ height: "200px" }}
                      src={value}
                    />
                  </>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      {viewPermssion ? (
        <>

          {showEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowEndDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowEndDateError(false)
                    navigate(`${REWARDS_CAMPAIGNS_ADD}?id=${tempId}`);
                  }}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {timeChange && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setTimeChange(false)}
            >
              <p>
                The selected publishing time has already passed. Could we proceed by
                submitting the new publish time for {getTime()}?
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                  }}
                >
                  Go back
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => checkEndDateForPublish()}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


          {showPublishDialog && (
            <Dialog
              className="alert-form"
              title={"Manual Publish Confirmation"}
              width={400}
              // height={280}
              onClose={() => setShowPublishDialog(false)}
            >
              <p>
                You've configured a Start Date and Time for this Campaign.
                By manually publishing now, the Start Date and Time will be updated to the current time. The End Date and Time will remain unchanged.
              </p>
              <p>Do you want to continue?</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                    setShowPublishDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => updateStatus()}
                >
                  Publish Now
                </div>
              </div>
            </Dialog>
          )}

          {showUpdateStatus && (
            <ShowDialog
              cancelbtn={() => {
                setShowUpdateStatus(false);
                setTempStatus("");
              }}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              isDisabled={tempStatus == 'Rejected' ? (tempStatus == tempOldStatus || rejectReason.trim() === "") : tempStatus == tempOldStatus}
              confrinbtn={checkTimeForPublish}
              children={
                tempStatus == "Rejected" && (
                  <div className="campaigns-dialog-reason-div">
                    <div>Reason <span style={{ color: "red" }}>*</span></div>
                    <div>
                      <TextArea placeholder="Enter Reason" style={{ "borderRadius": "5px", minHeight: "100px" }} value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
                    </div>
                  </div>
                )
              }
              dropdownData={tempStatusData.map(status => status.name)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {loading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          {detailLoading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (


            <div className="campaigns_detail_main_box">
              <div className="campaigns_detail_child_box">
                <div className="campaigns_detail_left_box">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      className="campaigns_detail_back"
                      onClick={() => navigate(REWARDS_CAMPAIGNS_LIST)}
                    >
                      <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                      Back
                    </div>
                    {
                      (
                        (
                          (detailData.status !== "Published" && detailData.status !== "Scheduled" && detailData.status !== "Approved" && AdminPermssion) ||
                          (detailData.status === "Approved" && ValidatorPermssion && !AdminPermssion)
                        ) &&
                        (
                          momentTZ.tz(`${detailData.end_date} ${detailData.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate() >= new Date() || AdminPermssion
                        )
                      ) && (
                        <div
                          className="campaigns_detail_edit"
                          onClick={() => navigate(`${REWARDS_CAMPAIGNS_ADD}?id=${id}`)}
                        >
                          <img src={EditIcon} />
                          Edit
                        </div>
                      )
                    }

                  </div>
                  <div className={detailData.status == "Pending Approval" ? "campaigns_detail_child_box_main_detail_box" : "campaigns_detail_child_box_main_detail_box_full_height"}>
                    <div className="campaigns_create_item_main_box_detail">
                      <div className="campaigns_create_item_main_box_title">
                        Campaign Info
                      </div>
                      <div style={{ margin: "10px" }} className="margin-bottom">
                        <RenderRow
                          title={"Campaign Name"}
                          value={detailData.name}
                          isImage={false}
                        />
                        <RenderRow
                          title={"Campaign Description"}
                          value={detailData.description}
                          isImage={false}
                        />

                        <RenderRow
                          title={"Start Date & Time"}
                          value={detailData.start_date && detailData.start_time ? momentTZ.tz(`${detailData.start_date} ${detailData.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
                          isImage={false}
                        />

                        <RenderRow
                          title={"End Date & Time"}
                          value={detailData.end_date && detailData.end_time ? momentTZ.tz(`${detailData.end_date} ${detailData.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
                          isImage={false}
                        />


                        <RenderRow
                          title={"Published/Scheduled Start Date & Time"}
                          value={detailData.published_date && detailData.published_time ? momentTZ.tz(`${detailData.published_date} ${detailData.published_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
                          isImage={false}
                        />

                        <RenderRow
                          title={"Published/Scheduled End Date & Time"}
                          value={detailData.published_end_date && detailData.published_end_time ? momentTZ.tz(`${detailData.published_end_date} ${detailData.published_end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
                          isImage={false}
                        />

                        <RenderRow
                          title={"Campaign Type"}
                          value={detailData.type}
                          isImage={false}
                        />

                        <RenderRow
                          title={"Campaign Category"}
                          value={detailData.category}
                          isImage={false}
                        />

                        {detailData.type != "Predefined Task Based" && (
                          <>
                            <RenderRow
                              title={"Reward Type"}
                              value={detailData.reward_type}
                              isImage={false}
                            />

                            <RenderRow
                              title={"Reward Provider"}
                              value={detailData.provider}
                              isImage={false}
                            />

                            <RenderRow
                              title={"Amount of Each Reward (in $)"}
                              value={`${detailData.value}`}
                              isImage={false}
                            />

                            <RenderRow
                              title={"Campaign Approver"}
                              value={`${detailData.approver_name}`}
                              isImage={false}
                            />
                          </>

                        )}

                        {detailData.status == 'Rejected' && (
                          <RenderRow
                            title={"Reject Reason"}
                            value={`${detailData.reason}`}
                            isImage={false}
                          />
                        )}

                        <RenderRow
                          title={"Uploaded image"}
                          value={detailData.images?.length > 0 ? detailData.images[0].url : ''}
                          isImage={true}
                        />
                      </div>

                      {detailData.type != "Predefined Task Based" && (
                        <div className="campaigns_create_upload_main_box">
                          <div className="campaigns_create_item_main_box_title">
                            Nominees list
                          </div>
                          {
                            (detailData.status == "Pending Nomination" && ApproverPermssion && nomineeList.length > 0) && (<div className="campaigns-select-all"
                              onClick={() => {
                                const allIds = nomineeList.map(nominee => nominee.pk); // ensure string array
                                setSelectedNominee(allIds);
                              }}>
                              Select All
                            </div>
                            )
                          }
                        </div>
                      )}

                      {
                        detailData.type != "Predefined Task Based" && (
                          (!nomineeList || nomineeList.length === 0) ?
                            (<div className="campaigns_empty">
                              <Icon>
                                <img alt="" src={NoNominee} />
                              </Icon>
                              <div className="campaigns_empty_title"> No nominees uploaded</div>
                            </div>)
                            :
                            (detailData.status == "Pending Nomination" && ApproverPermssion) ? (
                              <PendingApprovalNomineeSortableTable data={nomineeList} selectedNominee={selectedNominee} setSelectedNominee={setSelectedNominee} categoryName={getCampaignLabel(detailData.category)} />
                            )
                              : (
                                <DetailNomineeSortableTable data={nomineeList} setData={setNomineeList} categoryName={getCampaignLabel(detailData.category)} />
                              )

                        )
                      }


                      {
                        detailData.type == "Predefined Task Based" && (
                          <>
                            <div className="campaigns_create_item_main_box_title">
                              Campaign Matrix
                            </div>
                            <div className="table-wrapper">
                              <table className="reward-configuration-table">
                                <thead>
                                  <tr>
                                    <th width="120px">
                                      Module {getSortIcon()}
                                    </th>

                                    <th width="110px">
                                      No. of Submission {getSortIcon()}
                                    </th>

                                    <th width="110px">
                                      Reward Points  {getSortIcon()}
                                    </th>

                                    <th >
                                      Earning Limit {getSortIcon()}
                                    </th>

                                    <th >
                                      Task description {getSortIcon()}
                                    </th>

                                    <th >
                                      Popup message {getSortIcon()}
                                    </th>

                                  </tr>
                                </thead>
                                <tbody>



                                  {rewardConfigurationList.map((item, index) => (
                                    <tr key={index}>
                                      <td className="reward-configuration-table-text">{item.module_name}</td>
                                      <td className="reward-configuration-table-text">{item.threshold}</td>
                                      <td className="reward-configuration-table-text">{item.point}</td>
                                      <td className="reward-configuration-table-text">{item.limit}</td>
                                      <td className="reward-configuration-table-text">{item.task_description}</td>
                                      <td className="reward-configuration-table-text">{item.popup_message}</td>
                                    </tr>
                                  ))}

                                </tbody>
                              </table>
                            </div>
                          </>
                        )

                      }


                    </div>
                  </div>

                  {(detailData.status == "Pending Nomination" && ApproverPermssion && nomineeList.length > 0) && (
                    <div className="campaigns-survey-footer">
                      <div className="footer-left-btn-groups">
                        <Button
                          className="footer-previous-btn font-family-poppins"
                          onClick={() => {
                            navigate(REWARDS_CAMPAIGNS_LIST);
                          }}
                        >
                          Cancel
                        </Button>
                      </div>

                      <div className="footer-right">
                        <Button
                          className="footer-next-btn"
                          onClick={(e) => {
                            setShowApproveConfirmDialog(true);
                          }}
                        //disabled={selectedNominee.length == 0}
                        >
                          Approve
                        </Button>
                      </div>
                    </div>
                  )
                  }
                </div>
                <div className="campaigns_detail_right_box">
                  <div className="campaigns_detail_right_status_box">
                    <div className="campaigns_detail_right_box_status_title">
                      Status
                    </div>
                    <div className={detailData.status == "Rejected" ? "campaigns_detail_right_box_status_subdetail_reject" : "campaigns_detail_right_box_status_subdetail"}>
                      {detailData && detailData.status
                        ? detailData.status
                        : "-"}
                    </div>
                  </div>
                  <div className="campaigns_detail_right_box_action_main_box">
                    <div className="campaigns_detail_right_box_action_title">
                      Actions
                    </div>

                    {(AdminPermssion && (detailData.status != "Rejected" && detailData.status != "Closed" && detailData.status != "Pending Nomination" && detailData.status != "Draft")) ? (
                      <div
                        className="campaigns_detail_right_box_action_edit"
                        onClick={() => clickUpdateStatus()}
                      >
                        Update Status &#x2192;
                      </div>
                    ) : (
                      ""
                    )}

                    {(!AdminPermssion && CampaignApproverPermssion && detailData.status == "Pending Approval" && localStorage.getItem("username") == detailData.approver_id) ? (
                      <div
                        className="campaigns_detail_right_box_action_edit"
                        onClick={() => clickUpdateStatus()}
                      >
                        Update Status &#x2192;
                      </div>
                    ) : (
                      ""
                    )}

                  </div>
                  <div className="campaigns_detail_right_box_action_main_box">
                    <div className="campaigns_detail_right_box_action_title">
                      Activity Trail
                    </div>
                    <div className={auditData.length <= 1 && "audit_bar_hide"}>
                      {auditLoading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={auditData}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {showApproveConfirmDialog && (
                <Dialog
                  className="alert-form"
                  title={"Confirmation"}
                  width={500}
                  // height={280}
                  onClose={() => setShowApproveConfirmDialog(false)}
                >
                  <p className="campaigns-dialog-text-align"><b>Confirm Approval</b></p>

                  <p className="campaigns-dialog-text-align" style={{ marginTop: "10px", marginBottom: "10px" }}><b>Are you sure you want to approve these nominees?</b></p>
                  <p className="campaigns-dialog-text-align">Once the campaign is published, the accepted nominees will immediately receive their coupons.</p>
                  <p className="campaigns-dialog-text-align" style={{ marginTop: "10px", marginBottom: "10px" }}>Unaccepted nominees will be excluded from the campaign.</p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "150px",
                        height: "40px",
                        borderRadius: "10px",
                        background: "white",
                        color: "#eb6e1f",
                        cursor: "pointer",
                        border: "1px solid #eb6e1f",
                      }}
                      onClick={() => {
                        setShowApproveConfirmDialog(false);
                      }}
                    >
                      Cancel
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "150px",
                        height: "40px",
                        borderRadius: "10px",
                        background: "#eb6e1f",
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setShowApproveConfirmDialog(false);
                        approveNomineeList();
                      }}
                    >
                      Submit
                    </div>
                  </div>
                </Dialog>
              )}
            </div>
          )}
        </>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )
      }
    </>
  );
};
